import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {AutoCompleteModule} from 'primeng/autocomplete';
import {DeviceDetectorModule} from 'ngx-device-detector';
import {GalleriaModule} from 'primeng/galleria';
import { CarouselModule } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';

import {NgxMaskModule} from 'ngx-mask';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {ToastrModule} from 'ngx-toastr';
import {NgxCaptchaModule} from 'ngx-captcha';

import {DeviceGuard} from '../guards/device-guard';

import {BuscaHoteisComponent} from './busca-hoteis/busca-hoteis.component';
import {BlogGuruComponent} from './blog-guru/blog-guru.component';
import {ChatComponent} from './chat/chat.component';
import {CategoriasHoteisComponent} from './categorias-hoteis/categorias-hoteis.component';
import {DepoimentosComponent} from './depoimentos/depoimentos.component';
import {FooterComponent} from './footer/footer.component';
import {HeaderComponent} from './header/header.component';
import {LayoutComponent} from './layout/layout.component';
import {PropostaComponent} from './proposta/proposta.component';
import {PropostaFacilitaComponent} from './proposta-facilita/proposta-facilita.component';
import {TabelaDiariasComponent} from './tabela-diarias/tabela-diarias.component';
import {TabelaDiariasFacilitaComponent} from './tabela-diarias-facilita/tabela-diarias-facilita.component';
import {TermoUsoComponent} from '../pages/proposta/termo-uso/termo-uso.component';
import {WhatsupComponent} from './whatsup/whatsup.component';
import {UrlPipe} from './pipe/url.pipe';
import {
    PropostaFacilitaConsumidorComponent
} from './proposta-facilita-consumidor/proposta-facilita-consumidor.component';
import {PropostaFacilitaPromocaoComponent} from './proposta-facilita-promocao/proposta-facilita-promocao.component';
import { SvgIconComponent } from './components/svg-icon/svg-icon.component';
import { NewHeaderComponent } from './components/new-header/new-header.component';
import { SearchHotelsComponent } from './components/search-hotels/search-hotels.component';
import { HotelsInformationsComponent } from './components/hotels-informations/hotels-informations.component';
import { SignatureInformationsComponent } from './components/signature-informations/signature-informations.component';
import { PlansInformationsComponent } from './components/plans-informations/plans-informations.component';
import { TipsComponent } from './components/tips/tips.component';
import { NewFooterComponent } from './components/new-footer/new-footer.component';
import {ClickOutsideDirective} from './directives/click-outside.directive';
import { PlansSimulatorComponent } from './components/plans-simulator/plans-simulator.component';
import { PartnerHotelsComponent } from './components/partner-hotels/partner-hotels.component';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { ClosedCartGuard } from '../guards/closed-cart-guard';
import { SlideMenuComponent } from './components/slide-menu/slide-menu.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ToastrModule.forRoot(),
        NgxMaskModule.forRoot(),
        AutoCompleteModule,
        GalleriaModule,
        CarouselModule,
        ButtonModule,
        PdfViewerModule,
        DeviceDetectorModule.forRoot(),
        NgxCaptchaModule,
    ],
    providers: [DeviceGuard, ClosedCartGuard, UrlPipe],
    declarations: [
        BlogGuruComponent,
        BuscaHoteisComponent,
        CategoriasHoteisComponent,
        ChatComponent,
        DepoimentosComponent,
        FooterComponent,
        HeaderComponent,
        LayoutComponent,
        PropostaComponent,
        PropostaFacilitaComponent,
        PropostaFacilitaConsumidorComponent,
        PropostaFacilitaPromocaoComponent,
        TabelaDiariasComponent,
        TabelaDiariasFacilitaComponent,
        TermoUsoComponent,
        WhatsupComponent,
        UrlPipe,
        SvgIconComponent,
        NewHeaderComponent,
        SearchHotelsComponent,
        HotelsInformationsComponent,
        SignatureInformationsComponent,
        PlansInformationsComponent,
        TipsComponent,
        NewFooterComponent,
        ClickOutsideDirective,
        PlansSimulatorComponent,
        PartnerHotelsComponent,
        VideoPlayerComponent,
        SlideMenuComponent,
    ],
    exports: [
        BlogGuruComponent,
        BuscaHoteisComponent,
        CategoriasHoteisComponent,
        ChatComponent,
        DepoimentosComponent,
        FooterComponent,
        HeaderComponent,
        LayoutComponent,
        PropostaComponent,
        PropostaFacilitaComponent,
        PropostaFacilitaConsumidorComponent,
        PropostaFacilitaPromocaoComponent,
        TabelaDiariasComponent,
        TabelaDiariasFacilitaComponent,
        TermoUsoComponent,
        WhatsupComponent,
        AutoCompleteModule,
        CommonModule,
        FormsModule,
        GalleriaModule,
        CarouselModule,
        ButtonModule,
        NgxCaptchaModule,
        NgxMaskModule,
        ReactiveFormsModule,
        RouterModule,
        ToastrModule,
        UrlPipe,
        SvgIconComponent,
        NewHeaderComponent,
        SearchHotelsComponent,
        HotelsInformationsComponent,
        SignatureInformationsComponent,
        PlansInformationsComponent,
        TipsComponent,
        NewFooterComponent,
        ClickOutsideDirective,
        PlansSimulatorComponent,
        PartnerHotelsComponent,
        VideoPlayerComponent,
        SlideMenuComponent,
    ]
})

export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule
        };
    }
}
